import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { updateConfig as globalUpdateConfig } from "../../../store/slices/Global";
import {
  useGetGiftCardListDataQuery,
  useUpdateGiftCardTableHeadDataMutation,
} from "../../../store/queries/User";
import {
  getGiftCardEditData,
  updateConfig,
} from "../../../store/slices/User/GiftCards/giftCardSlice";
import { IconText } from "@wac-ui-dashboard/wac_component_library";
import { toast } from "react-toastify";
import { deleteGiftCard } from "./api";
const useGiftCards = () => {
  let paginationOptions = [
    { label: "10 Per page", value: 10 },
    { label: "20 Per page", value: 20 },
    { label: "30 Per page", value: 30 },
  ];
  const [showImageModal, setShowImageModal] = useState(false);
  const [imageData, setImageData] = useState("");
  const dispatch = useDispatch();
  const giftCardState = useSelector((state) => state.giftCard);
  const { selectedId } = useSelector((state) => state.giftCard);
  const { showEditModal } = useSelector((state) => state.global);
  const {
    data: giftCardList = {},
    isLoading,
    isFetching,
    refetch,
  } = useGetGiftCardListDataQuery({
    page_size: giftCardState?.currentPageSize,
    page: giftCardState?.currentPage,
    sort: giftCardState?.sortBy,
    sort_order: giftCardState?.sortOrder,
    search: giftCardState?.search,
  });
  const [updateGiftCardFields] = useUpdateGiftCardTableHeadDataMutation();

  const handleCreateClick = () => {
    dispatch(
      updateConfig((state) => {
        state.showCreateModal = !state.showCreateModal;
        state.imagePreview = "";
        state.imageName = "";
        state.arabicImagePreview = "";
        state.arabicImageName = "";
        state.isEdit = false;
        state.giftCardEditData = {};
      })
    );
  };
  useEffect(() => {
    if (giftCardState.clearSelection) {
      dispatch(
        updateConfig((state) => {
          state.clearSelection = false;
        })
      );
    }
    // eslint-disable-next-line
  }, [giftCardState.clearSelection]);

  const handleSearch = (e) => {
    dispatch(
      updateConfig((state) => {
        state.search = e.target.value;
        state.currentPage = 1;
      })
    );
  };
  const handleClearClick = () => {
    dispatch(updateConfig((state) => (state.search = "")));
  };

  const handleEditColumnsClick = () => {
    dispatch(
      globalUpdateConfig((state) => {
        state.showEditModal = !state.showEditModal;
      })
    );
  };

  const handleViewImage = (data) => {
    setShowImageModal(() => true);
    setImageData(data);
  };

  const getRow = (field, data) => {
    const rows = {
      common: (field, data) => <p className="pro-mb-0">{data[field]}</p>,
      image_url: (field, data) => {
        return (
          <div className="no-wrap">
            <IconText
              icon={
                <span className="material-symbols-outlined x4">imagesmode</span>
              }
              title={`${"View Photo"}`}
              onClick={() => handleViewImage(data?.image_url)}
            />
          </div>
        );
      },
      alias_image_url: (field, data) => {
        return (
          <div className="no-wrap">
            <IconText
              icon={
                <span className="material-symbols-outlined x4">imagesmode</span>
              }
              title={`${"View Photo"}`}
              onClick={() => handleViewImage(data?.alias_image_url)}
            />
          </div>
        );
      },
      alias_title: (field, data) => {
        return <p className="pro-rtl">{data?.alias_title}</p>;
      },
      alias_description: (field, data) => {
        return <p className="pro-rtl">{data?.alias_description}</p>;
      },
    };
    return rows?.[field]?.(field, data) ?? rows["common"](field, data);
  };

  const handleSort = (label) => {
    if (giftCardState.sortBy === label) {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortOrder = giftCardState.sortOrder === "asc" ? "desc" : "asc";
        })
      );
    } else {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortBy = label;
          state.sortOrder = "asc";
        })
      );
    }
  };

  const handleDeleteModal = (e) => {
    dispatch(
      updateConfig((state) => {
        state.showDeleteModal = !state.showDeleteModal;
        state.selectedId = e?.[0];
      })
    );
  };

  const handleDelete = async () => {
    const response = await deleteGiftCard(selectedId);
    if (response && response?.data?.status_code === 200) {
      toast.success(response?.data?.message);
      dispatch(
          updateConfig((state) => {
            state.currentPage = 1;
            state.search="";
          })
      );
      setTimeout(() => {
          refetch();
        }, 0);
    } else {
      toast.error(`Something went wrong!`);
      console.error("Error", response?.data?.errors, response?.message);
    }
    handleDeleteModal();
    dispatch(
      updateConfig((state) => {
        state.clearSelection = true;
      })
    );
  };

  const handlePagination = (page) => {
    dispatch(
      updateConfig((state) => {
        state.currentPage = page;
      })
    );
  };
  const handlePageSize = ({ value: page_size }) => {
    dispatch(
      updateConfig((state) => {
        state.currentPageSize = page_size;
        state.currentPage = 1;
      })
    );
  };
  const closeImageModal = () => {
    setShowImageModal(() => false);
    setImageData("");
  };

  const handleEditAction = (e) => {
    dispatch(
      updateConfig((state) => {
        state.showCreateModal = true;
        state.selectedId = e?.[0];
        state.isEdit = true;
      })
    );
    dispatch(getGiftCardEditData(e?.[0]));
  };
  const handleClose = () => {
    dispatch(
      updateConfig((state) => {
        state.showCreateModal = false;
        state.giftCardEditData = {};
        state.isEdit = false;
      })
    );
  };

  return {
    isLoading,
    imageData,
    isFetching,
    giftCardList,
    giftCardState,
    showEditModal,
    showImageModal,
    paginationOptions,
    handleEditColumnsClick,
    updateGiftCardFields,
    handleDeleteModal,
    handleCreateClick,
    handlePagination,
    handleClearClick,
    handleEditAction,
    closeImageModal,
    handlePageSize,
    handleSearch,
    handleClose,
    handleSort,
    handleDelete,
    refetch,
    getRow,
  };
};

export default useGiftCards;
